"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fountainApplicantTokenDeserialize = void 0;
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
function fountainApplicantTokenDeserialize(value, id) {
    const object = (0, deserializeObject_1.default)(value);
    return {
        id: (0, deserializeString_1.deserializeString)(id),
        applicantId: (0, deserializeString_1.deserializeString)(object.applicantId),
    };
}
exports.fountainApplicantTokenDeserialize = fountainApplicantTokenDeserialize;
